import { useState } from "react";
import { NavLink, useLocation } from 'react-router-dom';

// Navigation links for the site
export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Research', path: '/research' },
  { label: 'Art', path: '/art' },
];

const Header = () => {
  const location = useLocation();
  const showName = location.pathname !== '/';
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header style={{ background: 'none', width: '100%', padding: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1em 2em', maxWidth: 1200, margin: '0 auto', position: 'relative' }}>
        <h1 className="name-title" style={{ margin: 0, fontSize: 'clamp(1.2rem, 3.4vw, 1.7rem)', fontWeight: 'lighter', color: '#00000089' }}>
          <NavLink
            to="/"
            style={{ textDecoration: 'none', color: 'inherit', visibility: showName ? 'visible' : 'hidden' }}
            end
          >
            Daphna Keidar
          </NavLink>
        </h1>
        <button
          className="menu-toggle"
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(m => !m)}
          style={{
            display: 'none',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 8,
            marginLeft: 16,
            zIndex: 20
          }}
        >
          <span style={{ display: 'block', width: 28, height: 3, background: '#222', borderRadius: 2, marginBottom: 6 }} />
          <span style={{ display: 'block', width: 28, height: 3, background: '#222', borderRadius: 2, marginBottom: 6 }} />
          <span style={{ display: 'block', width: 28, height: 3, background: '#222', borderRadius: 2 }} />
        </button>
        <nav>
          <ul className={`nav-menu${menuOpen ? ' open' : ''}`} onClick={() => setMenuOpen(false)}>
            {NAV_LINKS.map(({ label, path }) => (
              <li key={path}>
                <NavLink
                  to={path}
                  className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
                  end={path === '/'}
                >
                  {({ isActive }) => (
                    <span aria-current={isActive ? 'page' : undefined}>{label}</span>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};
export default Header;

